"use client"

import {useContext} from 'react';
import {ThemeContext} from '../../utils/ThemeContext';

export const awards = [
	{
		name: 'Channel Pro Award',
		image_dark: '/img/CP_award.png',
		image_light: '/img/CP_award-light.png',
		description: '',
		link: 'https://www.channelpronetwork.com/2025/11/17/irvine-cybersecurity-conference-for-msps/'
	},
	{
		name: 'Channel Pro Live Editor\'s Choice Award',
		image_light: '/img/2023-CP-Event-Award-Editor-sChoiceAward-dark-bg.png',
		image_dark: '/img/2026_CP_Event_Award-Editors-Choice-Award.png',
		description: '',
		link: 'https://events.channelpronetwork.com/'
	},
	{
		name: 'Channel Pro Best Software Solution Award',
		image_light: '/img/2026-CP-Award-BestSoftware-dark-bg.png',
		image_dark: '/img/2026-CP-Award-BestSoftware-light.png',
		description: '',
		link: 'https://events.channelpronetwork.com/'
	}
];




const Compliance = ({ title = 'Industry Recognitions', subtitle }) => {
	const { theme } = useContext(ThemeContext);



	const certifications = awards.map((el, index) => {
		const { name, image_dark, image_light, description, link } = el;
		  const imgSrc = theme === 'dark' ? image_light : image_dark;
		return (
			<div key={index} className='compliance-item'>
				<a href={link}>
					<div className='compliance-logo' style={{ backgroundImage: `url(${imgSrc})` }} aria-label={name}></div>
				</a>
				{description && <p className='compliance-description'>{description}</p>}
			</div>
		);
	});

	return (
		<section className='compliance'>
			<div className='container'>
				{title && (
					<div className='subtitle-container'>
						<h3 className='subtitle'>{title}</h3>
					</div>
				)}
				<div className='compliance-grid'>{certifications}</div>
			</div>
		</section>
	);
};

export default Compliance;
